import { Component, HostBinding, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { OtherService } from 'src/app/Service/other.service';
import { Location } from '@angular/common';
import { NotificationService } from 'src/app/Service/notification.service';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import axios from 'src/app/Service/axios';
declare let $: any;

@Component({
  selector: 'device',
  templateUrl: './device.component.html',
})

export class DeviceComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private _location: Location,
    private router: Router,
    private otherService: OtherService,
    private route: ActivatedRoute,
    private notifyService: NotificationService,
    private gurdService: GurdServiceService
  ) {
    this.getItem();

  }

  ngOnInit(): void {

    this.sabtModelGps.disable();

    this.sabtModelGps.controls['strUnitId'].enable();

    if (this.carId != 0 && this.carId != null) {
      this.sabtModelGps.enable();
      // this.sabtModelGps.controls['strUnitId'].disable();
      this.imeIInp = true;
      this.isLoading = false;
    }

  }

  sabtModelGps: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    strUserName: new FormControl(''),

    strPassword: new FormControl(''),

    strRepeatPassword: new FormControl(''),

    iGPS: new FormControl('', Validators.required),

    strCellNo: new FormControl('', Validators.required),

    strUnitId: new FormControl('', Validators.required),

  });

  carType: any;

  carImg: any;

  carWork: any;

  gpsType: any;

  selector: boolean = false;

  isLoading: boolean = true;

  carId: number = 0;

  singelCar: any;

  imeIInp: boolean = false;

  isScannerVisible: boolean = false;

  getItem = async () => {
    const resp = await axios.post(
      `GetMobileIcon`
    );
    this.carImg = resp.data;

    const resp2 = await axios.post(
      `GetGPSType`
    );
    this.carType = resp2.data;

    const resp3 = await axios.post(
      `GetMobileType`
    );
    this.carWork = resp3.data;

    const resp4 = await axios.post(`GetGPS`);
    this.gpsType = resp4.data;

  };

  goBack() {
    this._location.back();
  }

  sabtGps = async () => {

    var model = this.sabtModelGps.value;

    if (this.sabtModelGps.invalid) {
      this.notifyService.showError('موارد ضروری را وارد کنید')
      this.otherService.markAllAsTouched(this.sabtModelGps)
      return
    }

    if (model.strPassword && (model.strPassword != model.strRepeatPassword)) {
      this.notifyService.showError('رمز عبور و تکرار رمز عبور یکسان نیستند');
      return;

    }

    const resp = await axios.post(`RegisterTracker`, this.otherService.stringNumberToNumber(model));

    let res = JSON.parse(resp.data)

    if (res.ISSessionExpired == true) {
      this.otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: '89' } });
      return;
    }

    if (res == -100) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }

    if (res.iResult == 0) {
      this.notifyService.showError(res.strError);
    }

    else {

      this.notifyService.showSuccess('با موفقیت ثیت شد');

      this.sabtModelGps.patchValue({
        strUserName: "",
        iGPS: "",
        strPassword: "",
        strRepeatPassword: "",
        strCellNo: "",
        strUnitId: "",
      })

      this.sabtModelGps.disable();
      this.sabtModelGps.controls['strUnitId'].enable();
      this.imeIInp = false;

      this.otherService.markAllAsUnTouched(this.sabtModelGps)

    }

  };

  Imei = async () => {

    var Imei = document.getElementById('Imei') as any;

    if (Imei.value == null || Imei.value == '') {
      this.notifyService.showError('لطفا شناسه را وارد  کنید');
      return;
    }

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

      strUnitID: Imei.value

    }

    const resp = await axios.post(`Mobile_Info`, model);

    let res = JSON.parse(resp.data.toString())

    if (res.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);

      this.router.navigate(['login'], { queryParams: { error: '90' } });

      return;
    }

    if (res.length > 0) {
      this.notifyService.showError('این ردیاب قبلا ثبت شده است');
    }

    if (res.iResult == 0) {
      return this.notifyService.showError(res.strError);
    }

    if (res.length == 0) {
      this.isLoading = false;
      this.sabtModelGps.enable();
      this.imeIInp = true;
      this.notifyService.showSuccess('ثبت خودرو بلا مانع است');
    }

  };

  checkNum(e: any) {
    if (isNaN(e.key)) {
      return false;
    }
    return true;
  }

  openScanner() {
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isMobile) {
      this.isScannerVisible = true;
    } else {
      alert('امکان باز کردن اسکنر فقط در گوشی وجود دارد');
    }
  }

  closeScanner() {
    this.isScannerVisible = false;
  }

  onCodeResult(resultString: string) {
    this.sabtModelGps.get('strUnitId')?.setValue(resultString);
    this.isScannerVisible = false;
    setTimeout(() => {
      this.Imei();
    }, 100);
  }

}
